module.exports = __webpack_public_path__ + "static/demo-08dbc8c694abb6c025ce137919182942.webm";